module.exports = __webpack_public_path__ + "img/qiangdan.e78f3b33.svg";